import { useState, useEffect } from 'react';
// components
import Dialog from '../../../components/dialog';
import Pagination from '../../../components/pagination';
// @devextreme
import DataGrid, { Column } from 'devextreme-react/data-grid';
// assets
import { ReactComponent as Search } from '../../../assets/form/search.svg';
import { ReactComponent as Close } from '../../../assets/button/close.svg';
// styles
import { SearchInput, Message, ButtonWrapper, PrimaryButton, TertiaryButton, Tags } from '../../../styles';
// apis
import { getUnregisteredGroups, registerGroups } from '../../../apis';

// ----------------------------------------------------------------------

interface Props {
  organizationId: string;
  handleClose: () => void;
  handleReset: () => void;
};

// ----------------------------------------------------------------------

const size = 10;

// ----------------------------------------------------------------------

export default function FormDialog({ organizationId, handleClose, handleReset }: Props) {
  
  const [ data, setData ] = useState({ content: [], totalElements: 0, totalPages: 1 });
  const { content: rows, totalElements: total, totalPages: pages } = data;

  const [ name, setName ] = useState('');
  const [ page, setPage ] = useState(0);
  
  useEffect(() => {
    ( async () =>
      await getUnregisteredGroups(setData, organizationId, name, page, size)
    )();
  }, []);

  const handlePage = (value: number) => {
    setPage(value-1);
    getUnregisteredGroups(setData, organizationId, name, value-1, size);
  };

  const handleSearch = () => {
    if ( name.length > 0 && name.replace(/ /g, '').length === 0 ) return;
    setPage(0);
    getUnregisteredGroups(setData, organizationId, name, 0, size);
  };

  const [ selected, setSelected ] = useState([]);

  const [ message, setMessage ] = useState(null);

  const handleSelected = async () => {
    if ( selected.length === 0 ) return setMessage('IoT 장비 그룹을 선택해 주세요.');

    const array = selected.map((item) => { return item.id });
    await registerGroups(organizationId, array)
    .then(() => {
      handleReset();
      handleClose();
    })
    .catch(() => {
      setMessage('요청하신 IoT 장비 그룹을 추가할 수 없습니다.\n나중에 다시 시도해 주세요.');
    });
  };

  return (
    <Dialog
      title='IoT 장비 그룹 추가'
      handleClose={handleClose}
    >
      <SearchInput>
        <input type='text' placeholder='IoT 장비 그룹을 입력하세요.' onChange={(event) => setName(event.target.value)} onKeyDown={(event) => { if(event.key === 'Enter') handleSearch() }} />
        <Search />
      </SearchInput>

      <DataGrid
        dataSource={rows}
        noDataText=''
        columnAutoWidth={true}
        paging={{enabled: false}}
        dataRowRender={({data}) => <TableRow row={data} selected={selected} setSelected={setSelected} />}
      >
        <Column caption='' dataField='iotGroupId' />
        <Column caption='IoT 장비 그룹' dataField='name' alignment='center' />
        <Column caption='주소' dataField='address' alignment='center' />
      </DataGrid>
      <Pagination page={page} pages={pages} size={size} handlePage={handlePage} />

      { selected.length > 0 &&
        <Tags>
          { selected.map((select) => (
            <div key={select.id}>
              { select.name }
              <button onClick={() => setSelected(selected.filter((item) => item.id !== select.id))} ><Close /></button>
            </div>
          )) }
        </Tags>
      }

      <Message $visible={message ? true : false}>{ message }</Message>

      <ButtonWrapper>
        <PrimaryButton onClick={() => handleSelected()}>추가</PrimaryButton>
        <TertiaryButton type='button' onClick={() => handleClose()}>취소</TertiaryButton>
      </ButtonWrapper>
    </Dialog>
  );
}

// ----------------------------------------------------------------------

interface RowProps {
  row: {
    iotGroupId: string;
    name: string;
    description: string;
  };
  selected: {
    id: string;
  }[];
  setSelected: React.Dispatch<React.SetStateAction<{}[]>>;
};

// ----------------------------------------------------------------------

function TableRow({ row, selected, setSelected }: RowProps){

  const handleChecked = (checked: any) => {
    if ( checked ) {
      setSelected((current) => [ ...current, { id: row.iotGroupId, name: row.name }]);
    } else {
      setSelected(selected.filter((item) => item.id !== row.iotGroupId));
    }
  };

  return (
    <tr>
      <td>
        <label htmlFor={`checkbox${row.iotGroupId}`}>
          <input type='checkbox' id={`checkbox${row.iotGroupId}`} checked={selected.some((item) => item.id === row.iotGroupId)} onChange={(event) => handleChecked(event.target.checked)} />
          <label htmlFor={`checkbox${row.iotGroupId}`} />
        </label>
      </td>
      <td><label htmlFor={`checkbox${row.iotGroupId}`}>{row.name}</label></td>
      <td><label htmlFor={`checkbox${row.iotGroupId}`}>{row.description}</label></td>
    </tr>
  );
}